import { Card, CardBody, Col } from 'reactstrap'
import { H4, P } from '../../../AbstractElements'
import { faqWidgetsData } from '../../../Data/MiscellaneousData/FaqData'
import FeatherIconCom from '../../../Utils/CommonComponents/CommonIcons/FeatherIconCom'

export default function FaqWidgets() {
    return (
        <>
            {faqWidgetsData.map((data) => (
                <Col xl={4} sm={data.smClass} key={data.id}>
                    <Card className="articles-cards">
                        <CardBody>
                            <div className="d-flex faq-widgets">
                                <div className="flex-grow-1">
                                    <H4>{data.title}</H4>
                                    <P>{data.paragraph}</P>
                                </div>
                                <FeatherIconCom iconName={data.icon}/>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </>
    )
}